import React, { useState } from 'react';
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  Button, 
  Box, 
  Avatar, 
  Menu, 
  MenuItem, 
  IconButton 
} from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import BusinessIcon from '@mui/icons-material/Business';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useAuth } from '../../contexts/AuthContext';

const Header = () => {
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    await logout();
    handleClose();
    navigate('/');
  };

  return (
    <AppBar
      position="static"
      className="custom-header"
      sx={{
        background: 'linear-gradient(180deg, #0f172a 0%, #111827 100%)',
        borderBottom: '1px solid rgba(255,255,255,0.08)'
      }}
    >
      <Toolbar>
        <BusinessIcon sx={{ mr: 2, color: '#f43f5e' }} />
        <Typography 
          variant="h6" 
          component={RouterLink} 
          to="/"
          sx={{ 
            flexGrow: 1, 
            textDecoration: 'none', 
            color: 'inherit',
            fontWeight: 'bold',
            letterSpacing: 0.5,
            textTransform: 'uppercase'
          }}
        >
          MetalConnect
        </Typography>
        
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <Button color="inherit" component={RouterLink} to="/" sx={{
            '&:after': { content: '""', display: 'block', height: 2, backgroundColor: 'transparent' },
            '&:hover:after': { backgroundColor: '#f43f5e' }
          }}>
            Inicio
          </Button>
          <Button color="inherit" component={RouterLink} to="/products" sx={{
            '&:after': { content: '""', display: 'block', height: 2, backgroundColor: 'transparent' },
            '&:hover:after': { backgroundColor: '#f43f5e' }
          }}>
            Productos
          </Button>
          {/* Enlace a RFQ ocultado por ahora */}
          {isAuthenticated && user?.role === 'supplier' && (
            <Button
              color="inherit"
              component={RouterLink}
              to="/publish-product"
              sx={{
                border: '1px solid rgba(255,255,255,0.2)',
                '&:hover': { borderColor: '#f43f5e', backgroundColor: 'rgba(244,63,94,0.08)' }
              }}
            >
              Publicar producto
            </Button>
          )}
          {isAuthenticated ? (
            <>
              <Button 
                color="inherit" 
                component={RouterLink} 
                to="/chat"
              >
                Chat
              </Button>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
              >
                <Avatar sx={{ width: 32, height: 32, bgcolor: '#f43f5e' }}>
                  {user?.username?.charAt(0)?.toUpperCase() || 'U'}
                </Avatar>
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem onClick={handleClose} component={RouterLink} to="/profile">
                  Mi Perfil
                </MenuItem>
                <MenuItem onClick={handleClose} component={RouterLink} to="/dashboard">
                  Dashboard
                </MenuItem>
                <MenuItem onClick={handleLogout}>
                  Cerrar Sesión
                </MenuItem>
              </Menu>
            </>
          ) : (
            <>
              <Button 
                color="inherit" 
                component={RouterLink} 
                to="/login"
              >
                Iniciar Sesión
              </Button>
              <Button 
                  variant="contained" 
                  sx={{ backgroundColor: '#f43f5e', '&:hover': { backgroundColor: '#e11d48' } }}
                component={RouterLink} 
                to="/register"
              >
                Registrarse
              </Button>
            </>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header; 